import React from 'react';

import { FormattedDate, useIntl } from 'react-intl';
import { FeatureFlag } from 'apis/FeatureFlagApi';
import { GMetrixTable } from 'components';

interface IProfileActivityProps {
	featureFlagData: FeatureFlag;
}

export function ActivityHistory({ featureFlagData }: IProfileActivityProps) {

    const { formatMessage } = useIntl();

    return (
        <div className="feature-flag-profile__activity-history">
            {featureFlagData.Changes && (
                <GMetrixTable
                    allowExport
                    columnData={[
                        {
                            field: 'DisplayName',
                            title: formatMessage({ id: 'name.5458f379', defaultMessage: 'Name' })
                        },
                        {
                            cellTitle: dataItem => dataItem.EarlyAccessRing.Name,
                            field: 'EarlyAccessRing.Name',
                            title: formatMessage({ id: 'ring.0c682750', defaultMessage: 'Ring' })
                        },
                        {
                            field: 'Comment'
                        },
                        {
                            field: 'Description'
                        },
                        {
                            field: 'ReleaseNotes'
                        },
                        {
                            field: 'UserName'
                        },
                        {
                            cell: ({ dataItem }) => (
                                <td>
                                    <FormattedDate value={new Date(dataItem.Date)} />
                                </td>
                            ),
                            field: 'Date',
                            title: formatMessage({ id: 'date_edited.f0d53a76', defaultMessage: 'Date Edited' })
                        }
                    ]}
                    bottomBarTableName={formatMessage({ id: 'history_changes.0afdb119', defaultMessage: 'History Changes' })}
                    rowData={featureFlagData.Changes}
                />
            )}
        </div>
    );

}
